import Immutable from 'immutable'

import { formatCalendarDate } from './dates'

export const getPatientInsuranceCompany = (patient, insuranceCompanies) => {
  if (!patient) return null
  const ic = patient.get('insuranceCompany')
  if (!ic) return null
  if (Immutable.Map.isMap(ic)) return ic
  if (insuranceCompanies && insuranceCompanies.has(ic)) {
    return insuranceCompanies.get(ic)
  }
  return null
}

export const patientRequiresCopay = (patient, insuranceCompanies) => {
  const insuranceCompany = getPatientInsuranceCompany(patient, insuranceCompanies)
  if (!insuranceCompany) return false
  return !!insuranceCompany.get('copayRequired')
}

export const getCopaidSessionsBalance = (patient) => {
  if (!patient || !patient.has('copaidSessionsBalance')) return 0
  return patient.get('copaidSessionsBalance')
}

export const getAppointmentCopayConsumed = (appointment, patient, insuranceCompanies) => {
  if (!appointment) return false
  if (appointment.has('copayConsumed')) return !!appointment.get('copayConsumed')
  return patientRequiresCopay(patient, insuranceCompanies)
}

export const getSavedCopayConsumedForAppointment = (appointment, selectedPatientId, patient, insuranceCompanies) => {
  if (!appointment || !selectedPatientId) return false
  if (String(appointment.get('patient')) !== String(selectedPatientId)) return false
  return getAppointmentCopayConsumed(appointment, patient, insuranceCompanies)
}

export const getOptimisticCopaidBalance = (patient, { savedCopayConsumed, currentCopayConsumed }) => {
  const balance = getCopaidSessionsBalance(patient)
  const delta = (savedCopayConsumed ? 1 : 0) - (currentCopayConsumed ? 1 : 0)
  return balance + delta
}

export const getCopaidSessionsByDate = (sessions) => {
  if (sessions && sessions.count() > 0) {
    return sessions.valueSeq()
      .map(session => Immutable.fromJS({
        _id: session.get('_id'),
        date: session.get('date'),
        title: formatCalendarDate(session.get('date')),
        value: session.get('amount'),
      }))
      .sortBy(session => session.get('date'))
      .reverse()
      .toArray()
  }
  return []
}
